

















































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import CustomText from '@/components/Globals/CustomText.vue';
import CustomInput from "@/components/Globals/Form/CustomInput.vue";
import CustomTextArea from "@/components/Globals/Form/CustomTextArea.vue";
import CustomCheckbox from "@/components/Globals/Form/CustomCheckbox.vue";

import VueRecaptcha from 'vue-recaptcha';
import { recaptchaHost } from '@/data/constants';

import shareYourDesign from "@/mixins/ShareYourDesign";

@Component({
  components: {
    CustomContainer,
    CustomText,
    CustomInput,
    CustomTextArea,
    CustomCheckbox,
    VueRecaptcha
  },
  mixins: [shareYourDesign],
})
export default class ShareYourDesignForm extends Vue {

  @Prop({default: false})
  enableCheck!: Boolean;

  created(){
    (this as any).beforeOpen();
    this.$eventBus.$on('closeShareYourDesignModal', (this as any).closeModal);
  }

  mounted() {
    if((window as any).grecaptcha && !(window as any).__recaptcha_api?.includes(recaptchaHost)) {
      (window as any).grecaptcha = {};
    }
  }

  destroyed() {
    (this as any).beforeClose();
  }
}
